<template>
  <vs-popup
    class="raw-material-allocated-work-orders-popup"
    title="RAW MATERIAL ALLOCATED WORK ORDERS"
    @close="onClickClose()"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <div id="rm-allocated-work-orders-popup" class="vx-row">
        <div class="vx-col lg:w-full w-full">
          <vs-table
            id="rm-allocated-work-orders-table"
            :max-items="meta.per_page ? meta.per_page : 10"
            :data="items"
            sort
            :sst="true"
            stripe
            class="table-dark-inverted table-auto vs-con-loading__container"
          >
            <template slot="thead">
              <vs-th> WO CODE </vs-th>
              <vs-th> ALLOCATED QTY (KG) </vs-th>
              <!-- <vs-th> STATUS </vs-th> -->
              <!-- <vs-th> ACTION </vs-th> -->
            </template>
            <template slot-scope="{ data }">
              <vs-tr
                class="text-sm"
                style="cursor: pointer"
                :key="indextr"
                v-for="(tr, indextr) in data"
              >
                <vs-td>
                  <HyperLink :id="tr.work_order.id" type="work-order">{{ tr.work_order.work_order_code }}</HyperLink>
                </vs-td>
                <vs-td>
                  {{ tr.allocated_quantity }}
                </vs-td>
                <!-- <vs-td>
                  {{ tr.type }}
                </vs-td> -->
                <!-- <vs-td>
                  <vx-tooltip text="View Work Order" position="left">
                    <vs-button
                      @click.stop="onClickViewWorkOrder(tr.work_order.id)"
                      size="small"
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                    ></vs-button>
                  </vx-tooltip>
                </vs-td> -->
              </vs-tr>
            </template>
          </vs-table>
          <vx-pagination
            v-on:changeMaxItems="changePage"
            :size-array="meta.total ? meta.total : 20"
            :max-items="perPage"
            description-body="Rows per page"
            description-connector="of"
            description-title="Records"
            description
            :description-items="descriptionItems"
            :total="meta.last_page ? meta.last_page : 0"
            v-model="page"
            class="p-5"
          >
          </vx-pagination>
        </div>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
import { defaultPagination, perPageList } from "@/constants/config";
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const InventoryRepository = RepositoryFactory.get("inventory");

function initialState() {
  return {
    open: false,
    id: "",
    items: [],
    filters: {},
    page: 1,
    total: 0,
    meta: {},
    sort: "",
    perPage: defaultPagination,
    descriptionItems: perPageList,
  };
}

export default {
  name: "RmAllocatedWorkOrdersPopUp",
  data() {
    return initialState();
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState());
        this.id = id;
        this.open = true;
        await this.fetchWorkOrders();
      } catch (error) {
        
      }
    },
    async refreshData() {
      await this.fetchWorkOrders();
    },
    onClickViewWorkOrder(id) {
      const path = `/pages/manufacturing/work-orders/${id}/details`;
      const route = this.$router.resolve({ path: path });
      window.open(route.href, "_blank");
    },
    async fetchWorkOrders() {
      try {
        await this.$vs.loading({
        container: '#rm-allocated-work-orders-popup',
        scale: 0.45
      })
        const { data } = await InventoryRepository.getListOfItemsConfirmedToWorkOrder(this.page, this.perPage, 'raw-material', this.id);
        this.items = data.data;
        this.meta = data.meta;
      } catch (error) {
        
      } finally {
        this.$vs.loading.close('#rm-allocated-work-orders-popup > .con-vs-loading');
      }
    },
    calculateTotalQty(data){
      let total = 0
      data.raw_materials.forEach(element => {
        total += Number(element.quantity_kg)
      });
      return total
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index];
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchWorkOrders();
    },
    onClickClose() {
      this.open = false;
    },
  },
  watch: {
    page(){
      this.fetchWorkOrders()
    },
    perPage() {
      this.fetchWorkOrders()
    },
  }
};
</script>

<style scoped>
.raw-material-allocated-work-orders-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 70% !important;
}
</style>
